module.exports = __webpack_public_path__ + "img/image_01.2fe8af63.jpg";